<div class="container">
  <h1 class=" p-2">Start {{ 'audit' | customerTerm }}</h1>
  <div class="lg:ml-8 p-2">
    <div class="px-4">
      <label class="block pt-4">
        <h3 class="">{{ 'audit' | customerTerm }} Type</h3>
        <select class="text-box w-full md:max-w-xl mt-2 standardTextSize" [(ngModel)]="selectedAuditType" (change)="filterAudits()">
          @for (at of AuditTypes; track at) {
            <option [ngValue]="at">
              {{ at.Description }}
            </option>
          }
        </select>
      </label>
      <label class="block pt-4">
        <h3 class="">{{ 'audit' | customerTerm }}</h3>
        <select class="text-box w-full md:max-w-xl mt-2 standardTextSize" [(ngModel)]="selectedAudit">
          @for (audit of Audits; track audit) {
            <option [ngValue]="audit">
              {{ audit.AuditName }}
            </option>
          }
        </select>
      </label>
    </div>
    <div class="p-4 mt-2">
      <button class="btn-primary-full w-full md:max-w-xl" (click)="startAudit()" [class.disabled]="!canStart"
        [disabled]="!canStart">
        @if (canStart) {
          <span class="standardTextSize">Next ></span>
        }
        @if (!canStart) {
          <span class="standardTextSize">Selecting...</span>
        }
      </button>
    </div>
    @if (selectedAudit != null) {
      <div class=" mx-3 ">
        <div class="border-grey-500 border-t-[1px] pb-2">
          <h5 class="mt-2 font-semibold">{{ 'audit' | customerTerm }} Details</h5>
          <p class="mb-2 mt-2">{{ 'audit' | customerTerm }} Type: <strong>{{selectedAudit.AuditInfo.AuditType.Description}}</strong></p>
          <p class="mb-2">{{ 'audit' | customerTerm }} Frequency: <strong>{{selectedAudit.AuditInfo.Frequency.Description}}</strong></p>
          <p>Last Updated: @if (selectedAudit.AuditInfo.LastUpdated == '0001-01-01T00:00:00') {
            <strong>Initial
            Version</strong>
            }@if (selectedAudit.AuditInfo.LastUpdated != '0001-01-01T00:00:00') {
            <strong
            >{{getHumanDate(this.selectedAudit.AuditInfo.LastUpdated)}}</strong>
          }
        </p>
        @if (selectedAudit.AuditInfo.ReportDescription.length != 0) {
          <div class="mt-2">
            <p class="standardTextSize">Report Description: <strong>{{ selectedAudit.AuditInfo.ReportDescription
            }}</strong>
          </p>
        </div>
      }
    </div>
    @if (selectedAudit.HistoricInfo.length>0) {
      <div class="border-grey-300 border-t-2">
        <h5 class="mt-4 font-semibold">Last Completed</h5>
        <div  class=" mt-2 ">
          <table class="">
            <thead>
              <!--<tr><th colspan="2">Audits Last Completed</th></tr>
              <tr>
                <th class="text-left">Location</th>
                <th class="text-left pl-2">Date</th>
              </tr>-->
            </thead>
            <tbody>
              @for (a of selectedAudit.HistoricInfo; track a) {
                <tr>
                  <td class="text-left">{{a.LocationName}}</td>
                  <td class="text-right pl-2">{{getHumanDate(a.LastCompleted)}}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  </div>
}


</div>

</div>
